<template>
<div class="chapter">
<div class="inner_page">
<p class="h2"><a id="cont"></a><a id="page_ix"><img alt="image" class="midd" height="27" src="images/left.jpg" width="25"/> Contents <img alt="image" class="midd" height="25" src="images/right.jpg" width="25"/></a></p><a id="page_ix">
</a><p class="cont"><a id="page_ix"></a><a class="nounder" href="#/xhtml/ch01#ch01"><span class="smallcaps">CHAPTER
                    1</span>: A Sticky Mess</a></p>
<p class="cont"><span class="nounder" href="#/xhtml/ch02#ch02" title="Link target outside of Sample"><span class="smallcaps">CHAPTER
                    2</span>: Butterscotch Volcano</span></p>
<p class="cont"><span class="nounder" href="#/xhtml/ch03#ch03" title="Link target outside of Sample"><span class="smallcaps">CHAPTER
                    3</span>: Big Burst</span></p>
<p class="cont"><span class="nounder" href="#/xhtml/ch04#ch04" title="Link target outside of Sample"><span class="smallcaps">CHAPTER
                    4</span>: Chocolate Aid</span></p>
<p class="cont"><span class="nounder" href="#/xhtml/ch05#ch05" title="Link target outside of Sample"><span class="smallcaps">CHAPTER
                    5</span>: Think Big</span></p>
<p class="cont"><span class="nounder" href="#/xhtml/ch06#ch06" title="Link target outside of Sample"><span class="smallcaps">CHAPTER
                    6</span>: A <span class="txit">Sugar-tastic</span> Idea</span></p>
<p class="cont"><span class="nounder" href="#/xhtml/ch07#ch07" title="Link target outside of Sample"><span class="smallcaps">CHAPTER
                    7</span>: Supersweet</span></p>
<p class="cont"><span class="nounder" href="#/xhtml/ch08#ch08" title="Link target outside of Sample"><span class="smallcaps">CHAPTER
                    8</span>: A Sticky Plan</span></p>
<p class="cont"><span class="nounder" href="#/xhtml/ch09#ch09" title="Link target outside of Sample"><span class="smallcaps">CHAPTER
                    9</span>: Pink and Positive</span></p>
<p class="cont"><span class="nounder" href="#/xhtml/ch10#ch10" title="Link target outside of Sample"><span class="smallcaps">CHAPTER
                    10</span>: Bubbles of Happiness</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cont.vue?dd73f6f0